import { ref, watchEffect } from 'vue';
export const PASSPORT = /^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)|(^[\d]{16}$)|(^[a-zA-Z\d]{7,10}$)/;
export const ktpCard = /^\d+$/;
export const huixiangzheng = /^[H|h]\d{8}$/; // 回乡证规则：H+8个数字
export const PAYMENTWAY = (status: string) => {
    let paymentStr = '';
    if (status === '600') {
        paymentStr = 'PAID';
    } else if (status === '602') {
        paymentStr = 'UNPAID';
    } else if (status === '608') {
        paymentStr = 'FAILED';
    }
    return paymentStr;
};
export const getClassIndex = (word: string) => {
    console.log(word, 'word');
    var classArr = ['', 'E', 'S', 'F', 'B'];
    let classInd = 1;
    for (let i = 0; i < classArr.length; i++) {
        if (word === classArr[i]) {
            classInd = i;
        }
    }
    return classInd;
};
